import { Component, OnInit } from '@angular/core';
import { Console } from '@angular/core/src/console';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { ToastrManager } from 'ng6-toastr-notifications';
import { forkJoin } from 'rxjs';
import { Customer } from 'src/app/models/customer';
import { CustomerAddress } from 'src/app/models/customer-address';
import { Presentation } from 'src/app/models/presentation';
import { Product } from 'src/app/models/product';
import { Travel } from 'src/app/models/travel';
import { TravelLine } from 'src/app/models/travel-line';
import { CustomerService } from 'src/app/services/customer.service';
import { PresentationsService } from 'src/app/services/presentations.service';
import { ProductService } from 'src/app/services/product.service';
import { TravelService } from 'src/app/services/travel.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-travel-support',
  templateUrl: './travel-support.component.html',
  styleUrls: ['./travel-support.component.css']
})
export class TravelSupportComponent implements OnInit {

  loading: boolean = false;
  travelId: number = null;
  travel: Travel = null;
  travelLine: TravelLine = null;
  //travelLines: TravelLine[] = []; //Lineas a agregar al viaje existente
  foundTravel: boolean = null;
  //Listas
  //Socio Inicio
  listSourceCustomers: Customer[] = [];
  listSourceCustomerAddresses: CustomerAddress[] = [];
  //Socio Final
  listTargetCustomers: Customer[] = [];
  listTargetCustomerAddresses: CustomerAddress[] = [];
  //Productos, Presentaciones
  listProducts: Product[] = [];
  listPresentations: Presentation[] = [];
  //Datos
  sourceCustomerId: any = null;
  sourceCustomerAddressId: any = []; //Dir Socio Inicio
  targetCustomerId: any = null;
  targetCustomerAddressId: any = []; //Dir Socio Final
  productId: any = null;
  presentationId: any = null;
  //Fecha de Entrega
	settingDeliveryDate = {};
  //Mapeo
  sourceCustomerMaps: any[] = [];
  targetCustomerMaps: any[] = [];
  productMaps: any[] = [];
  presentationMaps: any[] = [];
  //Direcciones
  addSourceCustomer: CustomerAddress = null;
  addTargetCustomer: CustomerAddress = null;
  //
  travelUpdate: boolean = false;

  constructor(private customerService: CustomerService, private travelService: TravelService, private productService: ProductService, private presentationService: PresentationsService, private toast: ToastrManager, private modalService: NgbModal, private utl: UtilitiesService) { }

  ngOnInit() { this.setDeliveryDateSettings(); }

  setDeliveryDateSettings(){
    this.settingDeliveryDate = {
      bigBanner: true,
      timePicker: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      defaultOpen: false,
      closeOnSelect: true
    }
  }

  searchTravel(){
    this.loading = true;
    if(this.travelId != null){
      this.travelService.getTravel(this.travelId).then( response => {
        this.travel = response;
        this.foundTravel = true;
        this.loading = false;
      }, error => {
        this.foundTravel = false;
        this.loading = true;
        this.toast.warningToastr('Ocurrió un error al obtener el viaje ' + this.travelId, '', {enableHTML: true});
      });
    }else{
      this.loading = false;
      this.toast.infoToastr('Debes ingresar un ID del viaje para realizar la busqueda.', '', {enableHTML: true});
    }
  }

  updRoute(modal, line){
    this.loading = true;
    //Obtener los productos y presentaciones
    forkJoin([this.customerService.getCustomers(), this.productService.getProducts(), this.presentationService.getPresentations()]).subscribe(([cust, prod, present]) => {
      this.setDefaultData();
      this.listSourceCustomers = cust;
      this.listTargetCustomers = cust;
      this.listProducts = prod;
      this.listPresentations = present;
      this.setValuesSourceCustomers(this.listSourceCustomers);
      this.setValuesTargetCustomers(this.listTargetCustomers);
      this.setValuesProducts(this.listProducts);
      this.setValuesPresentations(this.listPresentations);
      this.travelLine = new TravelLine();
      this.travelLine = line;
      this.sourceCustomerId = this.travelLine.source_customer_id;
      this.listSourceCustomerAddresses = this.listSourceCustomers.find(sc => sc.id == this.sourceCustomerId).directions;
      this.addSourceCustomer = this.listSourceCustomerAddresses.find(sc => sc.id == this.travelLine.source_customer_address_id);
      this.targetCustomerId = this.travelLine.target_customer_id;
      this.listTargetCustomerAddresses = this.listTargetCustomers.find(tc => tc.id == this.targetCustomerId).directions;
      this.addTargetCustomer = this.listTargetCustomerAddresses.find(tc => tc.id == this.travelLine.target_customer_address_id);
      this.productId = this.travelLine.product_id;
      this.presentationId = this.travelLine.presentation_id;
      this.loading = false;
      this.travelUpdate = true;
      this.modalService.open(modal, {size: 'lg', centered: true, windowClass: 'bigger'}); //Si se carga la informacion se muestra la modal
    }, error => {
      this.loading = true;
      this.toast.warningToastr('Ocurrió un error al obtener los datos del viaje a actualizar.', '', {enableHTML: true});
    });
  }

  /*Elimina linea registrada del viaje*/
  deleteRoute(modal, line){
    this.travelLine = line;
    this.modalService.open(modal, {size: 'lg', centered: true, windowClass: 'bigger'});
  }

  /*Abre modal para crear nuevo ruta*/
  newRoute(modal){
    this.loading = true;
    //Obtener los clientes, productos y presentaciones
    forkJoin([this.customerService.getCustomers(), this.productService.getProducts(), this.presentationService.getPresentations()]).subscribe(([cust, prod, present]) => {
      this.setDefaultData();
      this.listSourceCustomers = cust;
      this.listTargetCustomers = cust;
      this.listProducts = prod;
      this.listPresentations = present;
      this.setValuesSourceCustomers(this.listSourceCustomers);
      this.setValuesTargetCustomers(this.listTargetCustomers);
      this.setValuesProducts(this.listProducts);
      this.setValuesPresentations(this.listPresentations);
      this.loading = false;
      this.travelUpdate = false;
      this.travelLine.order_id = null;
      this.modalService.open(modal, {size: 'lg', centered: true, windowClass: 'bigger'}); //Si se carga la informacion se muestra la modal
    }, error => {
      this.loading = true;
      this.toast.warningToastr('Ocurrió un error al obtener los datos necesarios para crear o editar el viaje.', '', {enableHTML: true});
    });
  }

  /*Se agrega la nueva linea a las lineas a agregar a la ruta*/
  addRoute(){
    this.loading = true;
    if(this.travelLine.source_customer_id > 0 && this.travelLine.source_customer != null && this.travelLine.source_customer_address_id > 0 && this.travelLine.source_customer_address){
      if(this.travelLine.target_customer_id > 0 && this.travelLine.target_customer != null && this.travelLine.target_customer_address_id > 0 && this.travelLine.target_customer_address != null)
      {
        if(this.travelLine.time > 0 && this.travelLine.gas > 0 && this.travelLine.meters > 0 && this.travelLine.ton > 0 && this.travelLine.line > 0)
        {
          //Se agrega la linea por linea para evitar errores en las lineas y tengan que volver a registrar todas la lineas
          this.travelLine = new TravelLine(); //Se resetea el objeto para poder agregar mas lineas
          this.setValuesSourceCustomers(this.listSourceCustomers);
          this.listSourceCustomerAddresses = [];
          this.setValuesTargetCustomers(this.listTargetCustomers);
          this.listTargetCustomerAddresses = [];
          this.setValuesProducts(this.listProducts);
          this.setValuesPresentations(this.listPresentations);
          this.addSourceCustomer = null;
          this.addTargetCustomer = null;
          this.loading = false;
          this.toast.successToastr('Linea fue agregada correctamente al viaje ' + this.travelId + '.', '', {enableHTML: true});
        }else{ this.loading = false; this.toast.warningToastr('Faltan datos por agregar para agregar la ruta.', '', {enableHTML: true}); }
      }else{ this.loading = false; this.toast.warningToastr('Faltan datos por completar para el Socio Final.', '', {enableHTML: true}); }
    }else{ this.loading = false; this.toast.warningToastr('Faltan datos por completar para el Socio Inicio.', '', {enableHTML: true}); }
  }

  /*Elimina la ruta desde BD*/
  delRoute(line: TravelLine){
    this.loading = true;
    this.travelService.delTravelRoute(line).then(response => {
      this.travel = response;
      this.loading = false;
      this.modalService.dismissAll(); //Cerramos la modal
      this.toast.successToastr('La ruta ha sido eliminada correctamente del viaje.', '', {enableHTML: true});
    }, error => {
      this.loading = false;
      this.toast.warningToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  setValuesSourceCustomers(sourCust: Customer[]){
    this.sourceCustomerMaps.push({id: 'null', text: 'Ninguno'});
    sourCust.forEach(sc => this.sourceCustomerMaps.push({id: sc.id, text: sc.rfc + " - " + sc.name}));
    this.sourceCustomerId = this.sourceCustomerMaps[0].id;
  }

  setValuesTargetCustomers(tarCust: Customer[]){
    this.targetCustomerMaps.push({id: 'null', text: 'Ninguno'});
    tarCust.forEach(tc => this.targetCustomerMaps.push({id: tc.id, text: tc.rfc + " - " + tc.name}));
    this.targetCustomerId = this.targetCustomerMaps[0].id;
  }

  setValuesProducts(prods: Product[]){
    this.productMaps.push({id: 'null', text: 'Ninguno'});
    prods.forEach(pr => this.productMaps.push({id: pr.id, text: "(" + pr.id + ") " + pr.name + " - " + pr.division}));
    this.productId = this.productMaps[0].id;
  }

  setValuesPresentations(presents: Presentation[]){
    this.presentationMaps.push({id: 'null', text: 'Ninguno'});
    presents.forEach(p => this.presentationMaps.push({id: p.id, text: p.name}));
    this.presentationId = this.presentationMaps[0].id;
  }

  updateSourceCustomer(event){
    if(event['value'] != 'null'){
      this.travelLine.source_customer_id = this.listSourceCustomers.find(sc => sc.id == event['value']).id;
      this.travelLine.source_customer = this.listSourceCustomers.find(sc => sc.id == event['value']).name;
      this.listSourceCustomerAddresses = this.listSourceCustomers.find(sc => sc.id == event['value']).directions; //Direcciones del socio inicio seleccionado
      this.travelLine.source_customer_address_id = this.listSourceCustomerAddresses.length > 0 ? this.listSourceCustomerAddresses[0].id : 0;
      this.travelLine.source_customer_address = this.travelLine.source_customer_address_id > 0 ? this.listSourceCustomerAddresses.find(sc => sc.id == this.travelLine.source_customer_address_id).name : '';
      this.addSourceCustomer = (this.travelLine.source_customer_address_id != 0) ? this.listSourceCustomerAddresses.find(sc => sc.id == this.travelLine.source_customer_address_id) : null;
    }else{
      this.travelLine.source_customer_id = 0;
      this.travelLine.source_customer = '';
      this.travelLine.source_customer_address_id = 0;
      this.travelLine.source_customer_address = '';
      this.listSourceCustomerAddresses = [];
      this.addSourceCustomer = null;
    }
  }

  updateTargetCustomer(event){
    if(event['value'] != 'null'){
      this.travelLine.target_customer_id = this.listTargetCustomers.find(tc => tc.id == event['value']).id;
      this.travelLine.target_customer = this.listTargetCustomers.find(tc => tc.id == event['value']).name;
      this.listTargetCustomerAddresses = this.listTargetCustomers.find(tc => tc.id == event['value']).directions; //Direcciones del socio final seleccionado
      this.travelLine.target_customer_address_id = this.listTargetCustomerAddresses.length > 0 ? this.listTargetCustomerAddresses[0].id : 0;
      this.travelLine.target_customer_address = this.travelLine.target_customer_address_id > 0 ? this.listTargetCustomerAddresses.find(tc => tc.id == this.travelLine.target_customer_address_id).name : '';
      this.addTargetCustomer = (this.travelLine.target_customer_address_id != 0) ? this.listTargetCustomerAddresses.find(tc => tc.id == this.travelLine.target_customer_address_id) : null;
    }else{
      this.travelLine.target_customer_id = 0;
      this.travelLine.target_customer = '';
      this.travelLine.target_customer_address_id = 0;
      this.travelLine.target_customer_address = '';
      this.listTargetCustomerAddresses = [];
      this.addTargetCustomer = null;
    }
  }

  updateProduct(event){
    if(event['value'] != 'null'){
      this.travelLine.product_id = this.listProducts.find(pr => pr.id == event['value']).id;
      this.travelLine.product_name = this.listProducts.find(p => p.id == event['value']).name;
    }else{
      this.travelLine.product_id = 0;
      this.travelLine.product_name = '';
    }
  }

  updatePresentation(event){
    if(event['value'] != 'null'){
      this.travelLine.presentation_id = this.listPresentations.find(e => e.id == event['value']).id;
      this.travelLine.presentation_name = this.listPresentations.find(e => e.id == event['value']).name;
    }else{
      this.travelLine.presentation_id = 0;
      this.travelLine.presentation_name = '';
    }
  }

  selSourceCustAddress(){
    if(this.travelLine.source_customer_address_id > 0){
      this.travelLine.source_customer_address = this.listSourceCustomerAddresses.find(sc => sc.id == this.travelLine.source_customer_address_id).name;
      this.addSourceCustomer = this.listSourceCustomerAddresses.find(sc => sc.id == this.travelLine.source_customer_address_id); //Formateamos la direccion seleccionada para mostrar
    }else{
      this.travelLine.source_customer_address = '';
      this.addSourceCustomer = null;
    }
  }

  selTargetCustAddress(){
    if(this.travelLine.target_customer_address_id > 0){
      this.travelLine.target_customer_address = this.listTargetCustomerAddresses.find(tc => tc.id == this.travelLine.target_customer_address_id).name;
      this.addTargetCustomer = this.listTargetCustomerAddresses.find(tc => tc.id == this.travelLine.target_customer_address_id); //Formateamos la direccion seleccionada para mostrar
    }else{
      this.travelLine.target_customer_address = '';
      this.addTargetCustomer = null;
    }
  }

  saveRoutes(){
    this.loading = true;
    this.travelLine.travel_id = this.travelId;
    this.travelLine.order_id = (this.travelLine.order_id != null) ? this.travelLine.order_id : null; //Para que pase el request
    this.travelService.addTravelLines(this.travelLine).then(response => {
      this.travel = response; //Devuelve el viaje actualizado con las nuevas lineas
      this.setDefaultData();
      this.modalService.dismissAll();
      this.loading = false;
      this.toast.successToastr('La línea se agregó correctamente al viaje ' + this.travelId, '', {enableHTML: true});
    }, error => {
      this.loading = false;
      this.toast.warningToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  updateRoute(){
    this.loading = true;
    this.travelService.updateTravelLines(this.travelLine).then(response => {
      this.travel = response; //Devuelve el viaje actualizado con las lineas actualizadas
      let travel_line_id = this.travelLine.id;
      this.setDefaultData();
      this.modalService.dismissAll();
      this.loading = false;
      this.toast.successToastr('La línea ' + travel_line_id + ' se actualizó correctamente', '', {enableHTML: true});
    }, error => {
      this.loading = false;
      this.toast.warningToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  setDefaultData(){
    this.travelLine = new TravelLine();
    this.sourceCustomerId = null;
    this.sourceCustomerAddressId = null;
    this.targetCustomerId = null;
    this.targetCustomerAddressId = null;
    this.productId = null;
    this.presentationId = null;
    this.listSourceCustomers = [];
    this.listSourceCustomerAddresses = [];
    this.listTargetCustomers = [];
    this.listTargetCustomerAddresses = [];
    this.listProducts = [];
    this.listPresentations = [];
    this.sourceCustomerMaps = [];
    this.targetCustomerMaps = [];
    this.productMaps = [];
    this.presentationMaps = [];
    this.addSourceCustomer = null;
    this.addTargetCustomer = null;
    this.travelUpdate = false;
  }

  changeTonTotalTravel(){ this.travel.ton_total = _.sumBy(this.travel.lines, (t) => { return Number(t.ton); }); }

  Number(number){ return (number)?Number(number):0; }
}
